import {
  Headcell10,
  Headcell100,
  Headcell11,
  Headcell12,
  Headcell200,
  Headcell250,
} from "../app/styles/styles";
import { ApplicationTitles } from "./HomePage";

export enum LoggedInUserDetailsActionDispatchTypes {
  USER_MANAGEMENT_LOADING = "USER_MANAGEMENT_LOADING",
  USER_MANAGEMENT_SUCCESS = "USER_MANAGEMENT_SUCCESS",
  USER_MANAGEMENT_ERROR = "USER_MANAGEMENT_ERROR",
  USER_MANAGEMENT_RESET = "USER_MANAGEMENT_RESET",
}

export enum UserMfaInfoActionDispatchTypes {
  USER_SEND_MFA_CODE_LOADING = "USER_SEND_MFA_CODE_LOADING",
  USER_SEND_MFA_CODE_SUCCESS = "USER_SEND_MFA_CODE_SUCCESS",
  USER_SEND_MFA_CODE_ERROR = "USER_SEND_MFA_CODE_ERROR",
  USER_SEND_MFA_CODE_RESET = "USER_SEND_MFA_CODE_RESET",
}

export enum UserVerifyMfaInfoActionDispatchTypes {
  USER_VERIFY_MFA_CODE_LOADING = "USER_VERIFY_MFA_CODE_LOADING",
  USER_VERIFY_MFA_CODE_SUCCESS = "USER_VERIFY_MFA_CODE_SUCCESS",
  USER_VERIFY_MFA_CODE_ERROR = "USER_VERIFY_MFA_CODE_ERROR",
  USER_VERIFY_MFA_CODE_RESET = "USER_VERIFY_MFA_CODE_RESET",
}

export enum UserListActionDispatchTypes {
  USER_DETAILS_INVOKE = "USER_DETAILS_INVOKE",
  USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS",
  USER_DETAILS_ERROR = "USER_DETAILS_ERROR",
  USER_DETAILS_RESET = "USER_DETAILS_RESET",
}

export enum UserDetailsInAdminActionDispatchTypes {
  USER_DEATILS_IN_ADMIN_LOADING = "USER_DEATILS_IN_ADMIN_LOADING",
  USER_DEATILS_IN_ADMIN_ERROR = "USER_DEATILS_IN_ADMIN_ERROR",
  USER_DEATILS_IN_ADMIN_SUCCESS = "USER_DEATILS_IN_ADMIN_SUCCESS",
  USER_DEATILS_IN_ADMIN_RESET = "USER_DEATILS_IN_ADMIN_RESET",
}

export enum MFAStatus {
  SUCCESS = "OTP verified successfully.",
  OTP_SEND = "OTP Send Successfully.",
  EXPIRED = "Your One-Time Password (OTP) verification has expired. Please request a new OTP to continue the process.",
  INCORRECT = "OTP verification failed. Please enter the correct OTP.",
  NOT_EXPIRED = "OTP was already shared, New OTP was not sent because the 8-hour policy has not expired.",
  OTP_LOCKED = "Your account has been locked out for 1 hour due to multiple failed login attempts. To unlock please reset your password, click on forgot password.",
}

export enum MasterRoleActionDispatchTypes {
  ROLE_LOADING = "ROLE_LOADING",
  ROLE_SUCCESS = "ROLE_SUCCESS",
  ROLE_ERROR = "ROLE_ERROR",
}
export const TangoLogoAltText = "Pronet 2.0 Logo";

export const DefaultPayloadUser = {
  providerPortalUser: {
    userId: "",
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    status: "",
    twoFactorEnabled: true,
    accessFailedCount: true,
    registrationDate: null,
    registrationSource: "",
    approver: null,
    mfaId: 2,
    mfaType: "",
    roleId: "",
    roleType: "",
    userCreated: "System",
  },
  userProviderList: [],
};

export const DefaultProvider = {
  userId: "",
  providerId: 0,
  dateCreated: "",
  name: "",
  formattedAddress: "",
  city: "",
  state: "",
  phoneNumber: "",
  npiId: 0,
};

export const UserListHeaderLabel = [
  { label: "First Name", flag: false, style: { cell: Headcell100 } },
  { label: "Last Name", flag: false, style: { cell: Headcell100 } },
  { label: "Email", flag: false, style: { cell: Headcell250 } },
  { label: "Role", flag: false, style: { cell: Headcell250 } },
  // { label: "Agency", flag: false, style: { cell: Headcell250 } },
  { label: "Status", flag: false, style: { cell: Headcell100 } },
  { label: "Approver", flag: false, style: { cell: Headcell200 } },
  { label: "Action", flag: false, style: { cell: Headcell10 } },
];

export const AgencyAccessLabel = [
  { label: "Allow PA", flag: false, style: { cell: Headcell12 } },
  { label: "NPI", flag: false, style: { cell: Headcell100 } },
  { label: "Agency Name", flag: false, style: { cell: Headcell100 } },
  { label: "Street1", flag: false, style: { cell: Headcell250 } },
  { label: "Street2", flag: false, style: { cell: Headcell250 } },
  { label: "City", flag: false, style: { cell: Headcell250 } },
  { label: "State", flag: false, style: { cell: Headcell11 } },
  { label: "Zip Code", flag: false, style: { cell: Headcell100 } },
];

export const AdminFilterBy = [
  { label: "Last Name", value: "lastName" },
  { label: "Email", value: "email" },
  { label: "Agency Name", value: "agency" },
  { label: "NPI", value: "npiId" },
];

export const AdminAccessFilterBy = [
  { label: "NPI", value: "npiId" },
  { label: "Agency Name", value: "agencyName" },
  { label: "City", value: "city" },
  { label: "State", value: "state" },
  { label: "Zip code", value: "zipcode" },
];

export type DropdownOption = {
  label: string;
  value: string | number;
  disabled?: boolean;
};

export const getValidMessageType = (str: string) => {
  return Object.values(ApplicationTitles).includes(str as ApplicationTitles) ? str : "";
};

export enum RegisterUserActionDispatchTypes {
  POST_REGISTER_USER_INVOKE = "POST_REGISTER_USER_INVOKE",
  POST_REGISTER_USER_SUCCESS = "POST_REGISTER_USER_SUCCESS",
  POST_REGISTER_USER_ERROR = "POST_REGISTER_USER_ERROR",
  POST_REGISTER_USER_RESET = "POST_REGISTER_USER_RESET",
}

export enum UserByClaimsActionDispatchTypes {
  GET_USER_BY_CLAIMS_INVOKE = "GET_USER_BY_CLAIMS_INVOKE",
  GET_USER_BY_CLAIMS_SUCCESS = "GET_USER_BY_CLAIMS_SUCCESS",
  GET_USER_BY_CLAIMS_ERROR = "GET_USER_BY_CLAIMS_ERROR",
  GET_USER_BY_CLAIMS_RESET = "GET_USER_BY_CLAIMS_RESET",
}

export enum SendForgotPasswordLinkActionDispatchTypes {
  SEND_FORGOT_PASS_INVOKE = "SEND_FORGOT_PASS_INVOKE",
  SEND_FORGOT_PASS_SUCCESS = "SEND_FORGOT_PASS_SUCCESS",
  SEND_FORGOT_PASS_ERROR = "SEND_FORGOT_PASS_ERROR",
  SEND_FORGOT_PASS_RESET = "SEND_FORGOT_PASS_RESET",
}

export enum ResetPassActionDispatchTypes {
  RESET_PASS_INVOKE = "RESET_PASS_INVOKE",
  RESET_PASS_SUCCESS = "RESET_PASS_SUCCESS",
  RESET_PASS_ERROR = "RESET_PASS_ERROR",
  RESET_PASS_RESET = "RESET_PASS_RESET",
}

export const CONFIRM_PASSWORD_ERROR_MESSAGE =
  "The password and confirmation password do not match.";

export const REAUTH_UNAVAILIBILITY_ERROR_MESSAGE =
  "This authorization is inactive. Please submit a FreshDesk ticket for further assistance or to reactivate the authorization.";

export enum AccessAdminListActionDispatchTypes {
  ACCESS_ADMIN_INVOKE = "ACCESS_ADMIN_INVOKE",
  ACCESS_ADMIN_SUCCESS = "ACCESS_ADMIN_SUCCESS",
  ACCESS_ADMIN_ERROR = "ACCESS_ADMIN_ERROR",
  ACCESS_ADMIN_RESET = "ACCESS_ADMIN_RESET",
}

export enum UpdateAgencyAccessListActionDispatchTypes {
  UPDATE_AGENCY_ACCESS_INVOKE = "UPDATE_AGENCY_ACCESS_INVOKE",
  UPDATE_AGENCY_ACCESS_SUCCESS = "UPDATE_AGENCY_ACCESS_SUCCESS",
  UPDATE_AGENCY_ACCESS_ERROR = "UPDATE_AGENCY_ACCESS_ERROR",
  UPDATE_AGENCY_ACCESS_RESET = "UPDATE_AGENCY_ACCESS_RESET",
}

export enum UserPageTrackActionDispatchTypes {
  USER_PAGE_TRACK_INVOKE = "USER_PAGE_TRACK_INVOKE",
  USER_PAGE_TRACK_SUCCESS = "USER_PAGE_TRACK_SUCCESS",
  USER_PAGE_TRACK_ERROR = "USER_PAGE_TRACK_ERROR",
  USER_PAGE_TRACK_RESET = "USER_PAGE_TRACK_RESET",
}

export enum SsoHpsClaimsStatusUrlActionDispatchTypes {
  SSO_HPS_CLAIMS_STATUS_INVOKE = "SSO_HPS_CLAIMS_STATUS_INVOKE",
  SSO_HPS_CLAIMS_STATUS_SUCCESS = "SSO_HPS_CLAIMS_STATUS_SUCCESS",
  SSO_HPS_CLAIMS_STATUS_ERROR = "SSO_HPS_CLAIMS_STATUS_ERROR",
  SSO_HPS_CLAIMS_STATUS_RESET = "SSO_HPS_CLAIMS_STATUS_RESET",
}

export enum SsoHppClaimsStatusUrlActionDispatchTypes {
  SSO_HPP_CLAIMS_STATUS_INVOKE = "SSO_HPP_CLAIMS_STATUS_INVOKE",
  SSO_HPP_CLAIMS_STATUS_SUCCESS = "SSO_HPP_CLAIMS_STATUS_SUCCESS",
  SSO_HPP_CLAIMS_STATUS_ERROR = "SSO_HPP_CLAIMS_STATUS_ERROR",
  SSO_HPP_CLAIMS_STATUS_RESET = "SSO_HPP_CLAIMS_STATUS_RESET",
}

export enum Bcbs_Tn_SSO_ActionDispatchTypes {
  BCBS_TN_SSO_INVOKE = "BCBS_TN_SSO_INVOKE",
  BCBS_TN_SSO_SUCCESS = "BCBS_TN_SSO_SUCCESS",
  BCBS_TN_SSO_ERROR = "BCBS_TN_SSO_ERROR",
  BCBS_TN_SSO_RESET = "BCBS_TN_SSO_RESET",
}
  
export const NotificationListLabel = [
  { label: "Title Of Notification", flag: false, style: { cell: Headcell100 } },
  { label: "Notification Type", flag: false, style: { cell: Headcell100 } },
  { label: "Date Published", flag: false, style: { cell: Headcell100 } },
  { label: "Uploaded By", flag: false, style: { cell: Headcell100 } },
  { label: "Deactivated By", flag: false, style: { cell: Headcell100 } },
  { label: "Edit", flag: false, style: { cell: Headcell10 } },
  { label: "Deactivate", flag: false, style: { cell: Headcell10 } },
];

export enum NotificationActionDispatchTypes {
  POST_NOTIFICATION_INVOKE = "POST_NOTIFICATION_INVOKE",
  POST_NOTIFICATION_SUCCESS = "POST_NOTIFICATION_SUCCESS",
  POST_NOTIFICATION_ERROR = "POST_NOTIFICATION_ERROR",
  POST_NOTIFICATION_RESET = "POST_NOTIFICATION_RESET",
}

export enum NotificationListActionDispatchTypes {
  NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS",
  NOTIFICATION_LIST_INVOKE = "NOTIFICATION_LIST_INVOKE",
  NOTIFICATION_LIST_ERROR = "NOTIFICATION_LIST_ERROR",
  NOTIFICATION_LIST_RESET = "NOTIFICATION_LIST_RESET",
}

export const NotificationFilterBy = [
  { label: "Notification Type", value: "notificationtype" },
  { label: "Date Published", value: "datepublished" },
];

export enum NotificationUpdateActionDispatchTypes {
  NOTIFICATION_UPDATE_SUCCESS = "NOTIFICATION_UPDATE_SUCCESS",
  NOTIFICATION_UPDATE_INVOKE = "NOTIFICATION_UPDATE_INVOKE",
  NOTIFICATION_UPDATE_ERROR = "NOTIFICATION_UPDATE_ERROR",
  NOTIFICATION_UPDATE_RESET = "NOTIFICATION_UPDATE_RESET"
}
 
export enum NotificationDeactivateActionDispatchTypes {
  NOTIFICATION_DEACTIVATE_INVOKE = "NOTIFICATION_DEACTIVATE_INVOKE",
  NOTIFICATION_DEACTIVATE_SUCCESS = "NOTIFICATION_DEACTIVATE_SUCCESS",
  NOTIFICATION_DEACTIVATE_ERROR = "NOTIFICATION_DEACTIVATE_ERROR",
  NOTIFICATION_DEACTIVATE_RESET = "NOTIFICATION_DEACTIVATE_RESET"
}

export enum UserLogoutActionDispatchTypes { 
  USER_LOGOUT_INVOKE = "USER_LOGOUT_INVOKE",
  USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS",
  USER_LOGOUT_ERROR = "USER_LOGOUT_ERROR",
  USER_LOGOUT_RESET = "USER_LOGOUT_RESET"
}

export enum Refresh_Token_SSO_ActionDispatchTypes {
  REFRESH_TOKEN_SSO_INVOKE = "REFRESH_TOKEN_SSO_INVOKE",
  REFRESH_TOKEN_SSO_SUCCESS = "REFRESH_TOKEN_SSO_SUCCESS",
  REFRESH_TOKEN_SSO_ERROR = "REFRESH_TOKEN_SSO_ERROR",
  REFRESH_TOKEN_SSO_RESET = "REFRESH_TOKEN_SSO_RESET",
}